<template>
  <div class="widget-wrapper insights-widget-placeholder">
    <div class="d-flex justify-content-between">
      <span class="widget-title">Meetings</span>
      <span class="tag">Coming soon</span>
    </div>
    <div class="d-flex align-items-start justify-content-between mt-20">
      <div class="placeholders-column">
        <img
          :src="placeholders.donutChart.src"
          alt="Meetings chart"
        />
        <img
          class="mt-20"
          :src="placeholders.paragraph.src"
          alt="Meetings description"
        />
      </div>
      <div class="action-column">
        <img
          :src="placeholders.columnChart.src"
          alt="Meetings chart"
        />
        <AppButton
          type="primary"
          block
          class="modal-launcher"
          @click="toggleDialog"
        >
          More info
        </AppButton>
      </div>
    </div>
    <AppDialog
      :show="showDialog"
      title="Meeting time"
      position="top"
      append-to-body
      @close="toggleDialog"
    >
      <div class="d-flex flex-column align-items-center">
        <section>
          <p>
            How much time does your team spend in meetings? They can be a key part of business, especially for remote
            teams, but too much time spent in meetings can kill productivity.
          </p>
          <p class="mt-20">
            This new widget will give you visibility on how much time members are spending in meetings so you can
            increase your team's efficiency.
          </p>
        </section>
        <img
          class="mt-30"
          width="60%"
          :src="dialogIllustration.src"
          alt="Meetings illustration"
        />
        <AppButton
          class="mt-30"
          type="primary"
          @click="toggleDialog"
        >
          OK, got it
        </AppButton>
      </div>
    </AppDialog>
  </div>
</template>

<script>
import { INSIGHTS_ASSETS as INSIGHTS } from '~/app_constants';
import AppButton from '~/components/AppButton.vue';
import AppDialog from '~/components/AppDialog.vue';

export default {
  name: 'InsightsMeetingsPlaceholder',
  components: {
    AppButton,
    AppDialog,
  },
  data: () => ({
    showDialog: false,
  }),
  computed: {
    placeholders() {
      return {
        donutChart: INSIGHTS.donut_chart_placeholder,
        paragraph: INSIGHTS.short_paragraph_placeholder,
        columnChart: INSIGHTS.column_chart_placeholder,
      };
    },
    dialogIllustration() {
      return INSIGHTS.meetings_dialog_illustration;
    },
  },
  methods: {
    toggleDialog() {
      this.showDialog = !this.showDialog;
    },
  },
};
</script>
